import { useEffect, useState } from 'react';
import { apiUrl } from './apiBase';
import { DEFAULT_SITE } from './siteDefaults';
import { FALLBACK_SEED_VARIETY_PRODUCTS, mergeSeedVarietyProductsFromSite } from './seedVarietyCatalog';
import { resolveSeedVarietyCategories } from './siteHeader';

/** Loads `/api/site` and merges `seedVarieties.families` with bundled fallback when empty. */
export function useSeedVarietyProducts() {
  const [site, setSite] = useState(() => JSON.parse(JSON.stringify(DEFAULT_SITE)));
  const [products, setProducts] = useState(FALLBACK_SEED_VARIETY_PRODUCTS);
  const [categories, setCategories] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(apiUrl('/api/site'))
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled) return;
        const effective =
          data && typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length
            ? data
            : JSON.parse(JSON.stringify(DEFAULT_SITE));
        setSite(effective);
        setProducts(mergeSeedVarietyProductsFromSite(effective));
        setCategories(resolveSeedVarietyCategories(effective));
      })
      .catch(() => {
        if (cancelled) return;
        const fallback = JSON.parse(JSON.stringify(DEFAULT_SITE));
        setSite(fallback);
        setProducts(mergeSeedVarietyProductsFromSite(fallback));
        setCategories(resolveSeedVarietyCategories(fallback));
      })
      .finally(() => {
        if (!cancelled) setReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { site, products, categories, ready };
}
